import type React from 'react'
import { Modal } from './Modal'
import { Button } from './Button'
import { colors, fontSize } from '../../styles/theme'

interface ConfirmModalProps {
  open: boolean
  title: string
  message: React.ReactNode
  confirmLabel?: string
  cancelLabel?: string
  danger?: boolean
  loading?: boolean
  /** Keeps the confirm button disabled, e.g. until a typed confirmation phrase matches. */
  confirmDisabled?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmModal({
  open, title, message,
  confirmLabel = 'Confirm', cancelLabel = 'Cancel',
  danger = false, loading = false, confirmDisabled = false,
  onConfirm, onCancel,
}: ConfirmModalProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      title={title}
      width={420}
      footer={
        <>
          <Button variant="ghost" onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={loading} disabled={confirmDisabled}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div style={{ fontSize: fontSize.base, color: colors.textSecondary, lineHeight: 1.5 }}>
        {message}
      </div>
    </Modal>
  )
}
